import { commonMessages } from 'helpers'

import type { IconName } from 'sw-components'

import messages from './messages'


const vaultsLimit = 100

const sortTypes: Record<'apy' | 'tvl' | 'performance', VaultsPage.SortFormParams['sort']> = {
  performance: 'Performance',
  apy: 'APY',
  tvl: 'TVL',
} as const

const filterTypes = {
  all: 'all',
  deposits: 'deposits',
} as const

const sortOptions: VaultsPage.SortOptions = [
  {
    title: commonMessages.performance,
    value: sortTypes.performance,
  },
  {
    title: commonMessages.apy,
    value: sortTypes.apy,
  },
  {
    title: commonMessages.tvl,
    value: sortTypes.tvl,
  },
]

const filterOptions: VaultsPage.FilterOptions = [
  {
    title: messages.tabs.all,
    value: filterTypes.all,
  },
  {
    title: messages.tabs.deposits,
    value: filterTypes.deposits,
  },
]

const emptyMessages: Record<VaultsPage.Filter, {
  message: Intl.Message
  icon: IconName
}> = {
  all: {
    message: messages.emptySearch,
    icon: 'icon/search',
  },
  deposits: {
    message: messages.emptyDeposits,
    icon: 'icon/vaultDeposit',
  },
} as const

export {
  sortTypes,
  vaultsLimit,
  filterTypes,
  sortOptions,
  filterOptions,
  emptyMessages,
}
